import { render, staticRenderFns } from "./sio.vue?vue&type=template&id=fd47513a&"
import script from "./sio.vue?vue&type=script&lang=js&"
export * from "./sio.vue?vue&type=script&lang=js&"
import style0 from "./sio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports